module.exports = __webpack_public_path__ + "media/images/athletes/3548-7507985db70c1e99d7e9b7d9e3eb0d2f.png";